var chunkToChildrenMap = {
	"48091": [
		5659,
		7875,
		45249,
		54461,
		6340,
		9150,
		45329,
		27036,
		78094,
		52437,
		33995,
		68597,
		61268,
		83037,
		8414,
		61402,
		25692,
		91216,
		61473,
		98469,
		24067,
		4619
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));